import vars from '../../../theme/vars';

const { colors, headings } = vars;

const navigationBarStyle = {
  tabsWrapper: {
    flex: 1,
    overflow: 'hidden',
  },
  logoImage: {
    //alignItems: 'center',
    //marginTop: 5,
    cursor: 'pointer',
  },
  modalTextStyle: {
    color: 'white',
    paddingTop: 12,
  },
  tabWrapper: {
    justifyContent: 'center',
    height: 50,
    borderLeft: '2px solid transparent',
  },
  selectedTabWrapper: {
    justifyContent: 'center',
    height: 50,
    backgroundColor: 'rgba(230,230,230,0.2)',
    borderLeft: '2px solid white',
  },
  tabTouchableContainerStyle: {
    cursor: 'pointer',
    alignItems: 'center',
    marginLeft: 7,
    marginRight: 25,
    // marginTop: 18,
    flexDirection: 'row',
    //justifyContent: 'center',
  },
  activeTint: {
    height: 3,
    width: '50%',
    alignSelf: 'center',
    backgroundColor: colors.primary.color2,
  },
  wrapperForBorderRadius: {
    backgroundColor: colors.sidebarBgBlackColor,
    flex: 1,
    overflow: 'hidden',
  },
  containerStyle: {
    backgroundColor: colors.white,
    paddingLeft: 14,
    paddingRight: 30,
    height: 80,
    flexDirection: 'row',
    alignItems: 'center',
    boxShadow: '0px 2px 6px rgba(154, 154, 154, 0.143521)',
    borderRadius: ' 0px 0px 8px 8px',
    marginBottom: 2,
  },
  tabText: {
    ...headings.sidebar,
    marginLeft: 10,
    color: colors.white,
  },
  selectedTabText: {
    ...headings.sidebar,
    marginLeft: 10,
    color: '#FFFFFF',
  },
  logout: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: 50,
    cursor: 'pointer',
    marginLeft: 12,
    marginRight: 12,
    marginBottom: 20,
    padding: 15,
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    boxShadow: '0 20px 70px 0 rgba(86, 89, 146, 0.1)',
    borderRadius: 10,
  },
  userInfoWrapper: {
    width: 32,
    height: 32,
    borderRadius: 16,
    borderWidth: 2,
    borderColor: colors.secondary.color2,
    flexDirection: 'row',
    alignItems: 'center',
    cursor: 'pointer',
    justifyContent: 'center',
  },
  usernameText: {
    ...headings.h9,
    textTransform: 'uppercase',
    color: colors.secondary.color2,
  },
  breadcrumbViewWrapper: {
    flexDirection: 'row',
    height: 60,
    backgroundColor: colors.primary.color5,
    alignItems: 'center',
    paddingLeft: 40,
    paddingRight: 30,
    justifyContent: 'space-between',
  },

  tabIconProperties: {
    width: 35,
    height: 35,
    backgroundColor: 'transparent',
    padding: 5,
    borderRadius: 10,
    filter:
      'invert(100%) sepia(0%) saturate(0%) hue-rotate(204deg) brightness(102%) contrast(105%)',
  },

  tabIconPropertiesForDealer: {
    width: 30,
    height: 30,
    backgroundColor: 'transparent',
    borderRadius: 10,
    filter:
      'invert(100%) sepia(0%) saturate(0%) hue-rotate(204deg) brightness(102%) contrast(105%)',
  },

  tabWrapperForDealer: {
    margin: '10px 0px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 50,
  },
  selectedTabWrapperForDealer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 50,
    backgroundColor: 'rgba(230,230,230,0.2)',
    borderLeft: '2px solid white',
    margin: '10px 0px',
  },

  tabTouchableContainerStyleForDealer: {
    cursor: 'pointer',
    alignItems: 'center',
    // marginTop: 18,
    flexDirection: 'row',
    justifyContent: 'center',
  },

  wrapperForBorderRadiusForDealer: {
    backgroundColor: colors.sidebarBgBlackColor,
    flex: 1,
    width: 60,
    overflow: 'hidden',
  },

  tabsWrapperForDealer: {
    display: 'flex',
    height: '78%',
    overflow: 'hidden',
  },
};

export default navigationBarStyle;
